import React from 'react';
import classNames from 'classnames';
import RadioButtonGroup from '../RadioButtonGroup/RadioButtonGroup';
import styles from './EditDishRadioButtonGroup.scss';

export default function EditDishRadioButtonGroup({ children, ...rest }) {
  return (
    <RadioButtonGroup
      className={styles.wrapper}
      itemClassName={classNames([styles.groupItem, rest.disabled && styles.groupItemDisabled])}
      {...rest}
    >
      {children}
    </RadioButtonGroup>
  );
}
